import React, { useEffect, useRef, useState } from "react";

function Teste3(props) {
  const url = "http://localhost:3000/teste2";
  const dados = {
    payment: {
      status: "CON",
      authorizer_code: "000",
      authorizer_message: "Transacao OK!",
      nit: "83c8e22f6c827fb8b28836d4bf0e2f68f1ee23294628413b1078539fa4cddeb6",
      merchant_order_id: "100000000324",
      authorizer_id: "1",
      acquirer_id: "125",
      acquirer_name: "Cielo",
      authorizer_date: "11/05/2023T16:56",
      authorization_number: "110115",
      merchant_usn: "3835138579",
      emrpay_usn: "230511061359500",
      mrpay_usn: "110115",
      host_usn: "000110115   ",
      payment_amount: "4000",
      payment_type: "C",
      issuer: "1",
      terminal_id: "ES000006",
      payment_date: "11/05/2023T16:56",
      payment_installments: "2",
    },
    checkout_web: {
      nsu_emrpay: "df88b4",
      merchant_order_id: "100000000324",
      transaction_type: "payment",
      redirect: "M",
      cart: {
        items: [
          {
            product_type: "4",
            product_name: "Pagamento compra",
            description_view: "4000",
          },
        ],
      },
      additional_data: {
        currency: "BRL",
        payer: {
          identification_number: "60696368607",
          name: "Thalyson",
          surname: "Luan Menezes Pereira",
          email: "thalyson.menezes@mrpay.com.br",
          phone: "98981486963",
          address_street_name: "Rua Nova Aurora",
          address_street_number: "336",
          address_neighborhood: "Aurora",
          address_street_complement: "bem ali",
          address_zip_code: "65060400",
          city: "São Luís",
          state: "MA",
        },
      },
    },
  };

  // const handler = () => {
  //   const queryString = Object.keys(dados)
  //     .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(dados[key])}`)
  //     .join("&");
  //   const urlRedirecionamento = `${url}?${queryString}`;
  //   window.location.assign(urlRedirecionamento);
  // };

  // const handler = () => {
  //   const paymentString = JSON.stringify(dados.payment);
  //   const urlRedirecionamento = `${url}?payment=${encodeURIComponent(paymentString)}`;
  //   window.location.assign(urlRedirecionamento);
  // };

  const handler = () => {
    const keys = Object.keys(dados);
    const queryStrig = keys
      .map((item) => {
        return `${item}=${encodeURIComponent(JSON.stringify(dados[item]))}`;
      }).join("&");
    const urlRedirecionamento = `${url}?${queryStrig}`;
    window.location.assign(urlRedirecionamento);
  };

  const cssStyle = {
    height: "60px",
    margin: "50px",
  };

  return (
    // <form id="redirectionForm" method="GET" action="http://localhost:3000/teste">
    //   <input type="hidden" name="dados" value="XYZ" />
    //   <input type="hidden" name="dados" value={4} />
    //   <input type="hidden" name="dados" value="fafasdfsdfsfd" />

    //   <button type="submit">clique</button>
    // </form>
    <>
      <button type="submit" style={cssStyle} onClick={handler}>
        Redirecionar
      </button>
    </>
  );
}

export default Teste3;
